import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-data\"><path d=\"M4 3h2v1H4zm0 4h2v1H4z\" /><path d=\"M9.9 12.5c-.2-.7-.7-1.2-1.4-1.4V10H12c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h3.5v1.1c-.7.2-1.2.7-1.4 1.4H2v1h4.1c.2.9 1 1.5 1.9 1.5s1.7-.6 1.9-1.5H14v-1zM3 3c0-.6.4-1 1-1h8c.6 0 1 .4 1 1v2H3zm1 6c-.6 0-1-.4-1-1V6h10v2c0 .6-.4 1-1 1zm4 5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol